import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'semantic-ui-react';
import { startCase, map } from 'lodash';
import { connect } from 'react-redux';
import {
  openDeleteGlobalOccurrenceModal,
  openOccurrenceEditModal
} from '../../../data/experimentalDesign/modalActions';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';

const OccurrencesList = props => {
  const shrinkString = string => {
    const maxSize = 20;
    if (string && string.length > maxSize) {
      return `${string.substring(0, maxSize)}...`;
    }
    return string;
  };

  const occurrencesRows = map(props.occurrences, occurrence => {
    const occurrenceValues = props.columns.map((key, i) => {
      return <Table.Cell key={key}>{shrinkString(occurrence[key])}</Table.Cell>;
    });

    return (
      <Table.Row key={occurrence.id}>
        {occurrenceValues}
        <Table.Cell width={1}>
          <Button
            onClick={() => {
              props.dispatch(openOccurrenceEditModal(occurrence, occurrence.type));
            }}
          >
            Edit
          </Button>
        </Table.Cell>
        <Table.Cell width={1}>
          <Button
            onClick={() => {
              props.dispatch(
                openDeleteGlobalOccurrenceModal(
                  occurrence.id,
                  occurrence.type,
                  occurrence.name,
                  occurrence.version_id
                )
              );
            }}
          >
            Delete
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  });

  const occurrenceHeader = props.columns.map(key => {
    return <Table.HeaderCell key={key}>{startCase(key)}</Table.HeaderCell>;
  });

  return (
    <PhotoBoothModal {...props}>
      <Table celled>
        <Table.Header>
          <Table.Row>
            {occurrenceHeader}
            <Table.HeaderCell>Edit</Table.HeaderCell>
            <Table.HeaderCell>Delete</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{occurrencesRows}</Table.Body>
      </Table>
    </PhotoBoothModal>
  );
};

OccurrencesList.propTypes = {
  ...PhotoBoothModal.propTypes,
  occurrences: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  editHandler: PropTypes.func,
  deleteHandler: PropTypes.func,
  columns: PropTypes.array // eslint-disable-line react/forbid-prop-types
};

OccurrencesList.defaultProps = {
  ...PhotoBoothModal.defaultProps,
  occurrences: [],
  columns: []
};

export default connect()(OccurrencesList);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/OccurrencesList.js